import { render } from "./MobileNavbar.vue?vue&type=template&id=7ea7c132"
import script from "./MobileNavbar.vue?vue&type=script&lang=ts"
export * from "./MobileNavbar.vue?vue&type=script&lang=ts"
script.render = render

export default script